<template>
  <div ref="kksList" class="check-bot-established-kks-list-wrapper">
    <ul
      :class="{
        'check-bot-established-kks-list': true,
        busy: isValidatingKks,
      }"
    >
      <li
        v-for="kks in kksList"
        :key="kks"
        :class="{
          'valid-check-bot-established-kks': isKksGreen(kks),
          'valid-not-existing-check-bot-established-kks': isKksYellow(kks),
          'invalid-check-bot-established-kks': isKksRed(kks),
        }"
        @click="handleKksClick(kks)"
      >
        {{ kks }}
        <font-awesome-icon :icon="['fas', 'check']" />
      </li>
    </ul>
  </div>
</template>

<script src="./CheckBotEstablishedKks.script.ts" lang="ts"></script>
<style src="./CheckBotEstablishedKks.style.scss" lang="scss" scoped></style>
